import { Typography, PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { dateFormat } from 'src/common/helpers/date.helpers';
import { InfoElement } from 'src/pages/projects/sub-pages/project-details/components/project-details-info/project-details-info.styles';
import { ITimeStripe } from 'src/pages/projects/projects.interfaces';

const TimeStripeBlock = ({ timeStripe }: { timeStripe: ITimeStripe }) => {
  const { t } = useTranslation(['common', 'projects']);

  return (
    <div>
      <InfoElement>
        <Typography weight="bold">{t('projects:task.timeStripeName')}:</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{timeStripe.name}</Typography>
      </InfoElement>
      <InfoElement>
        <Typography weight="bold">{t('projects:labels.plannedHours')}:</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {timeStripe.plannedHours} hr
        </Typography>
      </InfoElement>
      <InfoElement>
        <Typography weight="bold">{t('common:labels.gantt')}:</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {timeStripe.gantt.name}
        </Typography>
      </InfoElement>
      {timeStripe.startDate && (
        <InfoElement>
          <Typography weight="bold">{t('projects:labels.startDate')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {dateFormat(timeStripe.startDate)}
          </Typography>
        </InfoElement>
      )}
    </div>
  );
};

export default TimeStripeBlock;
